import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from '@common/interfaces/id';
import { IID_OL_ACTIVATION_REQUEST } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDolActivationRequestState extends EntityState<IID_OL_ACTIVATION_REQUEST, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_ACTIVATION_REQUEST })
@InterfaceDataStore(InterfaceName.ACTIVATION_REQUEST)
export class IIDolActivationRequestStore extends EntityStore<IIDolActivationRequestState> {
  constructor() {
    super([]);
  }
}
